"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var jsx_runtime_1 = require("@emotion/react/jsx-runtime");

var Icon = function Icon() {
  return (0, jsx_runtime_1.jsxs)("svg", {
    fill: "currentColor",
    width: "100%",
    height: "100%",
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 421.11 280.5",
    children: [(0, jsx_runtime_1.jsx)("path", {
      d: "M346.4,350.24A57.59,57.59,0,1,1,404,292.65,57.65,57.65,0,0,1,346.4,350.24Zm0-98.18A40.59,40.59,0,1,0,387,292.65,40.64,40.64,0,0,0,346.4,252.06Z",
      transform: "translate(-65.54 -152.41)"
    }), (0, jsx_runtime_1.jsx)("path", {
      d: "M346.4,387.06a94.41,94.41,0,1,1,94.41-94.41A94.51,94.51,0,0,1,346.4,387.06Zm0-171.82a77.41,77.41,0,1,0,77.41,77.41A77.5,77.5,0,0,0,346.4,215.24Z",
      transform: "translate(-65.54 -152.41)"
    }), (0, jsx_runtime_1.jsx)("path", {
      d: "M346.4,432.9c-77.33,0-140.25-62.91-140.25-140.25S269.07,152.41,346.4,152.41s140.25,62.91,140.25,140.24S423.73,432.9,346.4,432.9Zm0-263.49A123.25,123.25,0,1,0,469.65,292.65,123.38,123.38,0,0,0,346.4,169.41Z",
      transform: "translate(-65.54 -152.41)"
    }), (0, jsx_runtime_1.jsx)("path", {
      d: "M346.4,432.9H74a8.5,8.5,0,0,1,0-17H346.4a8.5,8.5,0,0,1,0,17Z",
      transform: "translate(-65.54 -152.41)"
    })]
  });
};

exports.default = Icon;